import { useState, useEffect } from "react";
import { useNotification } from "./useNotification";
import { useApiErrorHandler } from "./useApiErrorHandler";
import useTokenRefresh from "./useTokenRefresh";
import httpclient from "../Utils";

export const useHoldReason = (options = {}) => {
  const {
    autoFetch = true, // Whether to fetch automatically on mount
    pagination = { page: 0, pageSize: 20 }, // Pagination settings
    sorting = [],
    transformData = null, // Optional data transformation function
  } = options;

  const [holdReasons, setHoldReasons] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [rowCount, setRowCount] = useState(0);
  const [refreshTrigger, setRefreshTrigger] = useState(0);
  const [apiResponse, setApiResponse] = useState(null);

  const showNotification = useNotification();
  const handleApiError = useApiErrorHandler();
  const { getTokenRefreshed: refresh } = useTokenRefresh();

  const fetchHoldReasons = async (customParams = {}) => {
    try {
      setLoading(true);
      setError(null);

      // Build query parameters if needed (for pagination, sorting, filtering)
      const params = {
        page: pagination.page + 1, // Convert to 1-based indexing if your API uses it
        limit: pagination.pageSize,
        ...customParams,
      };

      // Add sorting parameters if provided
      if (sorting.length > 0) {
        const sortField = sorting[0].field;
        const sortOrder = sorting[0].sort;
        params.sortBy = sortField;
        params.sortOrder = sortOrder;
      }

      const res = await httpclient.get("/hold-reason", { params });
      const { data } = res;
setApiResponse(data);
      if (data.status === 200) {
        const stations = transformData ? transformData(data.data) : data.data;
        setHoldReasons(stations);
        setRowCount(data.meta?.total || data.count || 0);
      } else {
        const errorMsg = data.msg || "Failed to fetch hold reasons";
        setError(errorMsg);
        showNotification("error", errorMsg);
      }
    } catch (error) {
      const errorMsg = "Failed to fetch hold reasons";
      setError(errorMsg);

      if (error.response?.status === 401) {
        refresh();
      } else {
        handleApiError(error);
      }
    } finally {
      setLoading(false);
    }
  };

  // Auto-fetch on mount and when refresh is triggered
  useEffect(() => {
    if (autoFetch) {
      fetchHoldReasons();
    }
  }, [refreshTrigger]);

  // Manual refresh function
  const refreshHoldReasons = (params = {}) => {
    if (autoFetch) {
      setRefreshTrigger((prev) => prev + 1);
    } else {
      fetchHoldReasons(params);
    }
  };

  return {
    holdReasons,
    loading,
    error,
    rowCount,

    fetchHoldReasons,
    refreshHoldReasons,
     apiResponse, 
  };
};
